import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal } from 'react-bootstrap'
import closeIcon from '../../assets/close.svg'
import './modals.css'

const ModalWrapper: React.ForwardRefRenderFunction<any, any> = ({ callback, title, children, className }, ref) => {

    const [showWrapper, setShowWrapper] = useState<boolean>(false)

    useImperativeHandle(ref, () => ({
        toggleModalWrapper: (bool: boolean) => { setShowWrapper(bool) }
    }), []);

    const closeModal = () => {
        if (typeof callback === 'function') {
            callback()
        }
        setShowWrapper(false)
    }

    let customClassName = typeof className === 'undefined' ? 'mf-cenrtal-modal' : `mf-cenrtal-modal ${className}`

    return (
        <Modal show={showWrapper} className={customClassName} centered>
            <Modal.Header className='justify-content-center mf-central-modal-header border-0 position-relative'>
                <div className="cursor-pointer mf-modal-close text-center" onClick={closeModal}>
                    <img width="25" height="25" src={closeIcon} alt="close" />
                </div>
                <Modal.Title className='text-sec-color'><strong>{title}</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    )
}

export default forwardRef(ModalWrapper)